export default __webpack_public_path__ + "static/media/magnifying-glass-4186151.1b71edb5.png";